<template>
  <div>
    <div v-if="$hasType('candidate')">
      <b-card
        :header="uLang('app.inspect_action_document')"
        header-tag="h4"
        class="no-card-padding"
        style="min-width: 100%"
      >
        <iframe
          v-if="$can('check-action-document-checks')"
          :src="
            route('export.actionprogress.filled', {
              actionProgress: this.actionProgressId,
              downloadType: 'stream',
            })
          "
          class="pull-right"
          frameborder="0"
          style="min-width: 100%; height: 60vh"
        ></iframe>
      </b-card>
    </div>
    <div v-else><!-- other like coach -->
      <b-card  :header="uLang('app.fill')" header-tag="h4" class="bg-default-card">
        <action-progress-document-form
          v-if="
            relation &&
            trajectory_enrolment &&
            milestone_progress &&
            action_progress
          "
          :relation="relation"
          :trajectory-enrolment="trajectory_enrolment"
          :milestone-progress="milestone_progress"
          :action-progress="action_progress"
          :overrideEndpoint="overrideEndpoint()"
          @form-dirty="handleFormDirty"
        />
        <rea-loader v-else :loading="true" />
      </b-card>
    </div>
    
  </div>
</template>

<script>
import ActionProgressDocumentForm from "~/components/forms/admin/relation/trajectory-enrolment/action-document-versions/form";
import { ReaLoader } from "~/components/helpers";


export default {
  name: "create",

  props: {
    relationId: {
      required: true,
    },
    trajectoryEnrolmentId: {
      required: true,
    },
    milestoneProgressId: {
      required: true,
    },
    actionProgressId: {
      required: true,
    },
  },

  data() {
    return {
      relation: null,
      trajectory_enrolment: null,
      milestone_progress: null,
      action_progress: null,
      originalData: {},
      isFormDirty: false,
    };
  },

  components: {
    "action-progress-document-form": ActionProgressDocumentForm,
    "rea-loader": ReaLoader,
  },

  created() {
    this.retrieveRelation();
    this.retrieveTrajectoryEnrolment();
    this.retrieveMilestoneProgress();
    this.retrieveActionProgress();
  },

  methods: {
    handleFormDirty(data) {
      this.isFormDirty = data.isDirty;
    },

    async retrieveRelation() {
      const { data } = await window.axios.get(
        route("relations.show", { relation: this.relationId })
      );
      this.relation = data;
    },

    async retrieveTrajectoryEnrolment() {
      const { data } = await window.axios.get(
        route("relations.trajectory-enrolments.show", {
          relation: this.relationId,
          trajectory_enrolment: this.trajectoryEnrolmentId,
        })
      );
      this.trajectory_enrolment = data;
    },

    async retrieveMilestoneProgress() {
      const { data } = await window.axios.get(
        route("relations.trajectory-enrolments.milestone-progresses.show", {
          relation: this.relationId,
          trajectory_enrolment: this.trajectoryEnrolmentId,
          milestone_progress: this.milestoneProgressId,
        })
      );
      this.milestone_progress = data;
    },

    async retrieveActionProgress() {
      const { data } = await window.axios.get(
        route(
          "relations.trajectory-enrolments.milestone-progresses.action-progresses.show",
          {
            relation: this.relationId,
            trajectory_enrolment: this.trajectoryEnrolmentId,
            milestone_progress: this.milestoneProgressId,
            action_progress: this.actionProgressId,
          }
        )
      );
      this.action_progress = data;
    },

    overrideEndpoint() {
      return route(
        "relations.trajectory-enrolments.milestone-progresses.action-progresses.action-document.store",
        {
          relation: this.relationId,
          trajectory_enrolment: this.trajectoryEnrolmentId,
          milestone_progress: this.milestoneProgressId,
          action_progress: this.actionProgressId,
        }
      );
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isFormDirty) {
      const confirmed = window.confirm("Leave without saving?");
      if (confirmed) {
        next(); 
      } else {
        return; 
      }
    } else {
      next(); 
    }
  },
  computed: {
    hasUnsavedChanges() {
      return this.checkUnsavedChanges();
    },
  },
};
</script>

<style lang="scss"></style>
